var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMicOff = function SvgMicOff(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306:1689)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70749 4.21484V8.52632C5.70749 10.0989 6.97696 11.3684 8.54959 11.3684C9.71764 11.3684 10.7184 10.6681 11.1561 9.66344L5.70749 4.21484ZM12.5505 11.0579C11.7091 12.3813 10.2321 13.2632 8.54927 13.2632C6.20927 13.2632 4.26717 11.5579 3.87875 9.33163C3.80296 8.86742 3.41454 8.52637 2.95033 8.52637C2.37243 8.52637 1.91769 9.03795 2.00296 9.60637C2.46717 12.4485 4.74085 14.6748 7.6019 15.0822V17.0527C7.6019 17.5737 8.02822 18.0001 8.54927 18.0001C9.07033 18.0001 9.49664 17.5737 9.49664 17.0527V15.0822C11.3092 14.8241 12.886 13.8359 13.9163 12.4237L12.5505 11.0579ZM14.8694 10.5484L13.3314 9.0103C13.4943 8.71836 13.7999 8.52637 14.1482 8.52637C14.7261 8.52637 15.1903 9.03795 15.0956 9.60637C15.0429 9.92888 14.9669 10.2435 14.8694 10.5484ZM11.3917 7.07063L5.9688 1.64773C6.41905 0.673798 7.40387 0 8.54959 0C10.1222 0 11.3917 1.26947 11.3917 2.84211V7.07063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.41421,
    y1: 1,
    x2: 16,
    y2: 15.5858,
    stroke: "#D92A25",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306:1689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMicOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mic-off.f66a254ef33334c1d73b18bfed688219.svg";